/*
The watch dog sets a timer. The timer is reset and restarted upon receiving a
dedicated event, e.g. 'http-response'. If the timer expires, it emits
an event itself, e.g. 'http-inactive'.

This service can host several different watch dogs.
*/
export class watchdogServices {
  constructor($rootScope, $timeout, APIConfig) {
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.APIConfig = APIConfig;

    this.timerHttp = null;
  }

  init() {
    this._initWatchDogHttp();
  }

  _initWatchDogHttp() {
    this.$rootScope.$on('http-response', () => {
      this._setTimerHttp();
    });

    this.$rootScope.$on('http-response-error', () => {
      this._setTimerHttp();
    });
  }

  _setTimerHttp() {
    this.$timeout.cancel(this.timerHttp);
    this.timerHttp = this.$timeout(() => {
      this.$rootScope.$emit('watchdog', {
        type: 'http-inactive',
        interval: this.APIConfig.watchDogIntervalHttp
      });
      console.debug('Watch dog barks: http!');
      this._setTimerHttp();
    }, this.APIConfig.watchDogIntervalHttp);
  }
}



// WEBPACK FOOTER //
// ./client/app/services/watchdog.services.js